import { Pipe, PipeTransform } from '@angular/core';

import { each, findIndex } from 'lodash';

@Pipe({ name: 'showDuplicateTicketsTypes', standalone: false })
export class ShowDuplicateTicketsTypesPipe implements PipeTransform {
  transform(ticketsTypeShow, ticketsTypeMatch, isShowNotMatch) {
    const tickets = [];

    if (!ticketsTypeShow) {
      return [];
    }

    if (!ticketsTypeMatch) {
      return [];
    }

    if (ticketsTypeShow && ticketsTypeMatch && !isShowNotMatch) {
      return ticketsTypeShow;
    }

    each(ticketsTypeShow, (ticket) => {
      const index = findIndex(ticketsTypeMatch, (type: any) => type.id === ticket.id && type.name !== ticket.name);

      if (index > -1) {
        tickets.push(ticket);
      }
    });

    return tickets;
  }
}

@Pipe({ name: 'showMissingTicketsTypes', standalone: false })
export class ShowMissingTicketsTypesPipe implements PipeTransform {
  transform(ticketsTypeShow, ticketsTypeMatch, isShowOnlyMissing) {
    const tickets = [];

    if (!ticketsTypeShow) {
      return [];
    }

    if (!ticketsTypeMatch) {
      return [];
    }

    if (ticketsTypeShow && ticketsTypeMatch && !isShowOnlyMissing) {
      return ticketsTypeShow;
    }

    each(ticketsTypeShow, (ticket) => {
      const index = findIndex(ticketsTypeMatch, (type: any) => type.id === ticket.id);

      if (index === -1) {
        tickets.push(ticket);
      }
    });

    return tickets;
  }
}
